<script>
  import { createEventDispatcher, onMount } from 'svelte'
  import Icon from 'fa-svelte'
  import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
  import {ProgressCircular} from 'smelte'

  export let items = [] // [{value: '1', text: 'abc'}, {value: '2', text: 'def'}]
  export let value = ''
  export let bg = 'bg-gray-200'
  export let loading = true
  export let add = ''
  export let remove = ''

  const dispatch = createEventDispatcher()

  let showList = false
  let filter = ''

  const emptyItem = {text:'', value:''}
  $: _items = [...items.filter(p => p.text.toUpperCase().includes(filter.toUpperCase()))]

  const optionsClassesDefault = 'absolute left-0 bg-white rounded elevation-2 w-full z-20 dark:bg-dark-500 mt-1' +
    ' overflow-y-auto text-base cursor-pointer'
  const classesDefault = 'cursor-pointer relative h-full'
  $: iconClasses = 'absolute top-0 right-0 pl-3 pr-3 text-base h-full flex items-center ' + bg
  $: inputClasses = 'px-3 input-text w-full h-full ' + bg
  $: optionsClasses = optionsClassesDefault.split(' ').filter(p => !remove.split(' ').includes(p)).join(' ') + ' ' + add

  const onHideListPanel = () => showList = false

  function listClickHandler (item) {
    dispatch('change', item)
    value = item.text
    showList = false
  }

  // TODO: move to utils.js
  function hideListAction (node, cb) {
    const onWindowClick = e => {
      if (!node.contains(e.target)) {
        cb()
      }
    }
    window.addEventListener('click', onWindowClick)
    return {
      destroy: () => {
        window.removeEventListener('click', onWindowClick)
      }
    }
  }

  function keyupHandler (key) {
    if (value === '') {
      showList = false
      return
    }
    showList = true
  }
</script>

<div class={classesDefault} use:hideListAction={onHideListPanel}>

<!--  <input type="text" class={inputClasses} bind:value={value} on:keyup={keyupHandler}/>-->
  <input type="text" class={inputClasses} bind:value={value} />

  <div class={iconClasses} on:click={() => {showList = !showList}}>
    <Icon icon={showList ? faChevronUp : faChevronDown} />
  </div>

</div>

{#if showList}
  <slot name="options">
    <div class={optionsClasses} style="max-height: 10rem">
      {#each _items as item}
        <div class="px-3 py-2 hover:bg-gray-300"
             on:click={() => { listClickHandler(item)}}>
          {item.text}
        </div>
      {/each}
      {#if loading}
        <div class="py-2 px-5 text-base flex">Loading  <ProgressCircular width=1 size="20" /></div>
      {/if}
      {#if !loading && _items.length === 0}
        <div class="py-2 px-5 text-base">No data found</div>
      {/if}
    </div>

  </slot>
{/if}
